import React from 'react';

import type { AIEventsInstrumentationConfig } from '@atlassian/ai-analytics';
import { AIEventsInstrumentationProvider } from '@atlassian/ai-analytics';

import { Attribution, ErrorBoundary } from '@confluence/error-boundary';

import {
	QUICK_SUMMARY_FEEDBACK_ENTRYPOINT_ID,
	WHITEBOARDS_SUMMARY_FEEDBACK_ENTRYPOINT_ID,
} from '../feedbackEntrypointIds';
import { FeedbackCollectorPropertiesProvider } from '../shared-components/FeedbackCollectorPropertiesProvider';

import { QuickSummaryStreamingComponent } from './QuickSummaryStreamingComponent';
import { QuickSummaryStreamingWrapper } from './QuickSummaryStreamingWrapper';

export type QuickSummaryProps = {
	contentId: string;
	spaceKey?: string;
	lastModifiedDate: string;
	source: string;
	contentPath: string;
	contentType: string;
	setIsOpen: (open: boolean) => void;
	isInObjectSidebar?: boolean;
};

export const QuickSummaryStreamingEntryPoint = (props: QuickSummaryProps) => {
	const contentType = props.contentType;

	const aiAnalyticsConfig: AIEventsInstrumentationConfig = {
		product: 'confluence',
		subproduct: 'confluence',
		source: 'confluencePage',
		aiFeatureName: 'quickSummary',
		proactiveGeneratedAI: 0,
		userGeneratedAI: 1,
		additionalAttributes: { contentType },
	};

	const feedbackEntryPointID =
		contentType === 'whiteboard'
			? WHITEBOARDS_SUMMARY_FEEDBACK_ENTRYPOINT_ID
			: QUICK_SUMMARY_FEEDBACK_ENTRYPOINT_ID;

	const quickSummaryComponent =
		contentType === 'page' || contentType === 'blogpost' ? (
			<QuickSummaryStreamingWrapper {...props} />
		) : (
			<QuickSummaryStreamingComponent {...props} />
		);

	return (
		<ErrorBoundary attribution={Attribution.SMARTS}>
			<FeedbackCollectorPropertiesProvider entrypointId={feedbackEntryPointID}>
				<AIEventsInstrumentationProvider config={aiAnalyticsConfig}>
					{quickSummaryComponent}
				</AIEventsInstrumentationProvider>
			</FeedbackCollectorPropertiesProvider>
		</ErrorBoundary>
	);
};
